import React from "react";
import ReactECharts from "echarts-for-react";
import { groupSeriesXY } from "../../utils/echartsSeries.js";
import { getModaliteColor, LABELS_POL, ANNEES_ANCRAGE } from "../../constants.js";

export default function MargeChart({ data, typeMarge }) {
  const valueKey = typeMarge === "cumul" ? "marge_cumulee" : "marge_annuelle";
  const groups = groupSeriesXY(data, { xKey: "year", groupKey: "modalite", valueKey });

  const anneeRef = ANNEES_ANCRAGE[0];
  const valeurRef = (points) => {
    const point = points.find((p) => p.x === anneeRef);
    return point ? point.y : -Infinity;
  };
  const groupsTries = [...groups].sort((a, b) => valeurRef(b.points) - valeurRef(a.points));

  const series = groups.map(({ group, points }) => ({
    name: LABELS_POL[group] || group,
    type: "line",
    symbol: "none",
    lineStyle: { width: 2, color: getModaliteColor(group) },
    itemStyle: { color: getModaliteColor(group) },
    data: points.map((p) => [p.x, Math.round(p.y)]),
  }));

  const option = {
    tooltip: {
      trigger: "axis",
      formatter: (params) => {
        const sorted = [...params].sort((a, b) => {
          const va = Array.isArray(a.value) ? a.value[1] : a.value;
          const vb = Array.isArray(b.value) ? b.value[1] : b.value;
          return vb - va;
        });
        let html = `${String(sorted[0]?.axisValue ?? "")}<br/>`;
        sorted.forEach((p) => {
          const v = Array.isArray(p.value) ? p.value[1] : p.value;
          html += `${p.marker} ${p.seriesName}: ${v}<br/>`;
        });
        return html;
      },
    },
    legend: {
      bottom: 0,
      type: "plain",
      textStyle: { fontSize: 14 },
      data: groupsTries.map((g) => LABELS_POL[g.group] || g.group),
    },
    grid: { left: 60, right: 20, top: 20, height: 380, containLabel: true },
    xAxis: {
      type: "value",
      name: "Année",
      nameLocation: "middle",
      nameGap: 30,
      min: "dataMin",
      max: "dataMax",
      axisLabel: { formatter: (v) => String(v) },
    },
    yAxis: {
      type: "value",
      name: typeMarge === "cumul" ? "Marge cumulée" : "Marge annuelle",
      nameLocation: "middle",
      nameGap: 55,
    },
    series:
      typeMarge === "annuelle"
        ? [
            ...series,
            {
              name: "zéro", type: "line", data: [], markLine: {
                silent: true, symbol: "none", lineStyle: { color: "#999", type: "dashed" },
                data: [{ yAxis: 0 }],
              }, tooltip: { show: false }, legendHoverLink: false,
            },
          ]
        : series,
  };

  const lignesTableau = groupsTries.map(({ group, points }) => {
    const valeurs = ANNEES_ANCRAGE.map((a) => {
      const point = points.find((p) => p.x === a);
      return point ? Math.round(point.y) : null;
    });
    return { group, label: LABELS_POL[group] || group, valeurs };
  });

  return (
    <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
      <div style={{ flex: "1 1 0" }}>
        <ReactECharts option={option} style={{ height: 500 }} notMerge lazyUpdate />
      </div>

      <div style={{ flex: "1.6 1 0", overflowX: "auto" }}>
        <table className="diagoeau-data-table diagoeau-table-centered">
          <thead>
            <tr>
              <th></th>
              {ANNEES_ANCRAGE.map((a) => (
                <th key={a}>{a}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {lignesTableau.map((ligne) => (
              <tr key={ligne.group}>
                <td>{ligne.label}</td>
                {ligne.valeurs.map((v, i) => (
                  <td key={i}>{v == null ? "—" : v.toLocaleString("fr-FR")}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}